import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()

	const [data, setData] = useState({ 'poses': [] })
	const [discounts, setDiscounts] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [externalMenu, setExternalMenu] = useState([])
	const [externalProducts, setExternalProducts] = useState([])
	const [orderDeliveryTypes, setOrderDeliveryTypes] = useState([])
	const [externalIntegrationTypes, setExternalIntegrationTypes] = useState([])

	async function searchWithFilter() {
		var filterUrl = `/external-integrations/${id}`

		var response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			const responsePoses = await GET('/helper/poses')
			if (responsePoses.data.length !== response.data.poses) {
				let missingItems = responsePoses.data.filter(item => !response.data.poses.some(existingItem => existingItem.id === item.id));
				response.data.poses.push(...missingItems);
			}

			setData(response.data);

			if (response.data.external_group_id) {
				const responseProducts = await GET(`/external-menu-products/${response.data.external_group_id}`)
				if (httpOk(responseProducts)) setExternalProducts(responseProducts.data)
			}
		}
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response
		if (id) response = await PUT('/external-integrations', data, { loader: true })
		if (!id) {
			response = await POST('/external-integrations', data, { loader: true })
			if (httpOk(response)) navigate(-1)
		}

		if (httpOk(response)) { }
	}

	function handleSettingChange(e, item, index) {
		var dataCopy = { ...data }

		dataCopy['poses'][index]['status'] = e.target.checked
		setData(dataCopy)
	}

	async function handleSelectExternalMenu(option) {
		setData({ ...data, 'external_group_id': option ? option.id : null })

		if (option && option.id) {
			const response = await GET(`/external-menu-products/${option.id}`)
			if (httpOk(response)) setExternalProducts(response.data)
		}
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getExternalMenus() {
		const response = await GET('/helper/external-menu')
		if (httpOk(response)) setExternalMenu(response.data)
	}

	async function getDiscounts() {
		const response = await GET('/external-discounts')
		if (httpOk(response)) setDiscounts(response.data)
	}

	async function getOrderDeliveryTypes() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderDeliveryTypes(response.data)
	}

	async function getExternalIntegrationTypes() {
		const response = await GET(`/helper/external-integration-types`)
		if (httpOk(response)) setExternalIntegrationTypes(response.data)
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setData({ ...data, 'poses': response.data });
	}

	function renderJson() {
		return <div><pre>{JSON.stringify(data, null, 2)}</pre></div>;
	}

	useEffect(() => {
		if (id) searchWithFilter()
		if (!id) getPoses()
		getPaymentTypes()
		getExternalMenus()
		getOrderDeliveryTypes()
		getExternalIntegrationTypes()
		if (1 === 2) getDiscounts()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('integrations')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-6">
							<div className="form-group">
								<label>{t('type')}<span className="required-mark">*</span></label>
								<Select
									options={externalIntegrationTypes}
									value={externalIntegrationTypes.find(option => option.id === data.integration_type_id) || ''}
									onChange={(option) => setData({ ...data, 'integration_type_id': option.id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="form-group">
								<label>{t('name2')}</label>
								<input type="text" className="form-control" name="name"
									autoComplete="off"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, 'name': e.target.value })} />
							</div>
							<div className="form-group w-100">
								<label>{t("description")}</label>
								<textarea className="form-control" name="description"
									autoComplete="off"
									value={data.description ?? ''}
									onChange={(e) => setData({ ...data, 'description': e.target.value })} />
							</div>

							<hr />
							<div className="d-flex gap-2">
								<div className="form-group w-75">
									<label>Webhook URL</label>
									<input type="text" className="form-control" name="webhook"
										disabled
										value={data.webhook ?? ''}
										onChange={() => { }} />
								</div>
								<div className="form-group w-25">
									<label>prefix</label>
									<input type="text" className="form-control" name="prefix"
										value={data.prefix ?? ''}
										onChange={(e) => setData({ ...data, 'prefix': e.target.value })} />
								</div>
							</div>
							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>Client ID</label>
									<input type="text" className="form-control" name="client_id"
										disabled
										value={data.client_id ?? ''}
										onChange={() => { }} />
								</div>
								<div className="form-group w-100">
									<label>Client Secret</label>
									<input type="text" className="form-control" name="client_secret"
										disabled
										value={data.client_secret ?? ''}
										onChange={() => { }} />
								</div>
							</div>

							<hr />

							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>{t('external_menu')}<span className="required-mark">*</span></label>
									<Select
										options={externalMenu}
										value={externalMenu.find(option => option.id === data.external_group_id) || ''}
										onChange={(option) => handleSelectExternalMenu(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
								<div className="form-group w-100">
									<label>{t('payment_type')}<span className="required-mark">*</span></label>
									<Select
										options={paymentTypes}
										value={paymentTypes.find(option => option.payment_type_id === data.payment_type_id) || ''}
										onChange={(option) => setData({ ...data, 'payment_type_id': option.payment_type_id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.payment_type_id}
									/>
								</div>
							</div>

							<div className="form-group w-100">
								<label>{t('delivery_type')}<span className="required-mark">*</span></label>
								<Select
									options={orderDeliveryTypes}
									value={orderDeliveryTypes.find(option => option.id === data.order_type_sub_id) || ''}
									onChange={(option) => setData({ ...data, 'order_type_sub_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<hr />
							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('auto_cheque_confirmation')}
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_auto_confirmed"
										checked={data.is_auto_confirmed ? true : false}
										onChange={(e) => setData({ ...data, 'is_auto_confirmed': e.target.checked })} />
								</div>
							</div>
							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('auto_cheque_deletion')}
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_auto_close_cheque"
										checked={data.is_auto_close_cheque ? true : false}
										onChange={(e) => setData({ ...data, 'is_auto_close_cheque': e.target.checked })} />
								</div>
							</div>
						</div>

						<div className="col-md-6">
							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>Vendor Client ID</label>
									<input type="text" className="form-control" name="vendor_client_id"
										value={data.vendor_client_id ?? ''}
										onChange={(e) => setData({ ...data, 'vendor_client_id': e.target.value })} />
								</div>
								<div className="form-group w-100">
									<label>Vendor Client Secret</label>
									<input type="text" className="form-control" name="vendor_client_secret"
										value={data.vendor_client_secret ?? ''}
										onChange={(e) => setData({ ...data, 'vendor_client_secret': e.target.value })} />
								</div>
							</div>

							<hr />

							<div className="form-group w-100">
								<label>{t('discount')}</label>
								<Select
									isClearable
									options={discounts}
									value={discounts.find(option => option.id === data.discount_service_id) || ''}
									onChange={(option) => setData({ ...data, 'discount_service_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('products')}</label>
								<Select
									isMulti
									options={externalProducts}
									value={data.products}
									onChange={(options) => setData({ ...data, 'products': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<hr />

							<label>{t('poses')}</label>
							<div className="table-responsive">
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '90%' }}>{t('name2')}</th>
											<th style={{ 'width': '10%' }}></th>
										</tr>
									</thead>
									<tbody>
										{data?.poses?.map((item, index) => (
											<tr key={index}>
												<td style={{ 'width': '33px' }} className="text-center">{item.id}</td>
												<td>{item.name}</td>
												<td className="d-flex justify-content-end">
													<div className="form-check form-switch form-switch-sm">
														<input type="checkbox" className="form-check-input"
															checked={item.status ? true : false}
															onChange={(e) => handleSettingChange(e, item, index)} />
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>

							<div className="d-none" style={{ 'height': '500px', 'overflow': 'auto' }}>
								<button className="btn btn-primary w-100">Проверка</button>
								{renderJson()}
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index